import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    version: {},
    userInfo: {},
    pwdTempData: {},
    mainActData: {},
    shareDomain: '',
    activityConfig: {},
    isShowPosterModal: false,
    copyModalData: {
      isShow: false,
      text: '',
      showBtn: false,
    },
    signModalData: {
      isShow: false,
    },
    yhTjb: {},
  },
  getters,
  mutations,
  actions,
  modules: {
  }
})
